
import http from '@/features/shared/http/client';
import { StoryboardFrame, StoryboardGenerationOptions } from '@/features/storyboard/types/storyboard.types';

export class StoryboardAIService {
    async generateStoryboard(sceneText: string, options?: StoryboardGenerationOptions): Promise<StoryboardFrame[]> {
        const response = await http.post<StoryboardFrame[]>('/generateStoryboardAI', { sceneText, options });
        return response.data;
    }

    /**
     * Generate an image for a specific frame and upload it to Firebase Storage.
     * Returns the public download URL.
     */
    async generateFrameImage(frameId: string, prompt: string, referenceImageUrl?: string): Promise<{ success: boolean; imageUrl: string }> {
        const response = await http.post<{ success: boolean; imageUrl: string }>('/generateStoryboardImage', { frameId, prompt, referenceImageUrl });
        return response.data;
    }

    async regenerateSingleFrame(frame: Partial<StoryboardFrame>, sceneText: string): Promise<StoryboardFrame> {
        const response = await http.post<StoryboardFrame>('/regenerateSingleFrame', { frame, sceneText });
        return response.data;
    }
}

export const storyboardAIService = new StoryboardAIService();
